import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const ProjectPhaseChart = ({ data, loading }) => {
  const COLORS = {
    planning: '#1B3A5C',
    permits: '#E8732A',
    foundation: '#2D5580',
    framing: '#1A7A4A',
    systems: '#D97706',
    finishing: '#4A6080',
    completed: '#6B7280'
  };

  const phaseLabels = {
    planning: 'Planning',
    permits: 'Permits',
    foundation: 'Foundation',
    framing: 'Framing',
    systems: 'Systems',
    finishing: 'Finishing',
    completed: 'Completed'
  };

  const chartData = data?.map(item => ({
    name: phaseLabels?.[item?.phase] || item?.phase,
    value: item?.count,
    phase: item?.phase
  })) || [];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-semibold text-foreground mb-1">{payload?.[0]?.name}</p>
          <p className="text-xs text-muted-foreground">
            Projects: {payload?.[0]?.value}
          </p>
        </div>
      );
    }
    return null;
  };

  if (loading) {
    return (
      <div className="bg-card border border-border rounded-xl p-6">
        <div className="flex items-center justify-center h-80">
          <Icon name="Loader2" size={32} className="animate-spin text-primary" />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground flex items-center gap-2">
            <Icon name="PieChart" size={20} className="text-primary" />
            Projects by Phase
          </h3>
          <p className="text-xs text-muted-foreground mt-1">Distribution across construction phases</p>
        </div>
      </div>
      {chartData?.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-80 text-muted-foreground">
          <Icon name="BarChart3" size={48} className="mb-2 opacity-50" />
          <p className="text-sm">No project data available</p>
        </div>
      ) : (
        <div className="w-full h-80">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                fill="var(--color-primary)"
                dataKey="value"
                label={({ name, percent }) => `${name} ${(percent * 100)?.toFixed(0)}%`}
              >
                {chartData?.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS?.[entry?.phase] || 'var(--color-muted)'} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend 
                verticalAlign="bottom" 
                height={36}
                wrapperStyle={{ fontSize: '12px' }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default ProjectPhaseChart;